module.exports = __webpack_public_path__ + "static/js/graphvizlib.wasm";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@hpcc-js/wasm/dist/graphvizlib.wasm
// module id = ibVK
// module chunks = 1